import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES, type CotizacionPosLocationState } from '../../config/routes';

const CotizacionVentaAltaRedirect: React.FC = () => {
  const location = useLocation();
  const navState = location.state as CotizacionPosLocationState | null;

  return (
    <Navigate
      replace
      to={ROUTES.ventas.cotizaciones.pos}
      state={navState?.ventaPendiente ? { ventaPendiente: navState.ventaPendiente } : undefined}
    />
  );
};

export default CotizacionVentaAltaRedirect;
